import regexString from '../../../../validations/validations-postal-code';
import { stripSpacesAndDashesFromInput } from './stripSpacesAndDashesFromInput';
/**
 * Finds Postal codes in string.
 * Initially, postal codes are not PII, but when having access to customer service systems,
 * due to the few amount of people inside a specific postal code, data can easily be tracked back.
 */
export function isPostalCode(input) {
    const cleanedInput = stripSpacesAndDashesFromInput(input);
    const regexp = new RegExp(regexString);
    return regexp.test(cleanedInput);
}
